import React, { useState, useEffect } from 'react';
import '../styles/projectsoftpower.css';

const SplashScreen = ({ onEnter }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const handleEnter = () => {
    setFadeOut(true);
    setTimeout(() => onEnter(), 600);
  };

  const culturalImages = [
    'https://images.unsplash.com/photo-1554907984-15263bfd63bd',
    'https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c',
    'https://images.unsplash.com/photo-1579783900882-c0d3dad7b119',
    'https://images.unsplash.com/photo-1724398915427-edc535c546fe',
    'https://images.unsplash.com/photo-1460881680858-30d872d5b530',
    'https://images.unsplash.com/photo-1478720568477-152d9b164e26',
  ];

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        zIndex: 9999,
        opacity: fadeOut ? 0 : 1,
        transition: 'opacity 0.6s ease-out',
        pointerEvents: fadeOut ? 'none' : 'all',
        background: '#FFFFFF'
      }}
    >
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridTemplateRows: 'repeat(2, 1fr)',
        gap: '2px',
        opacity: 0.15
      }}>
        {culturalImages.map((img, index) => (
          <div key={index} style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            <img src={img} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
        ))}
      </div>

      <div
        style={{
          position: 'relative',
          zIndex: 3,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          opacity: isLoaded ? 1 : 0,
          transform: isLoaded ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
        }}
      >
        <img 
          src="https://customer-assets.emergentagent.com/job_soft-influence-1/artifacts/g6p6wvoo_Copy%20of%20Copy%20of%20Copy%20of%20PROJECT%20SOFT%20POWER%20LOGO.PNG"
          alt="Project Soft Power"
          style={{
            width: 'auto',
            height: '160px',
            marginBottom: '40px',
            background: 'white',
            padding: '20px',
            borderRadius: '8px'
          }}
        />

        <h1 style={{
          fontFamily: 'Google Sans, Roboto, sans-serif',
          fontSize: 'clamp(32px, 5vw, 56px)',
          fontWeight: '400',
          color: '#202124',
          marginBottom: '16px',
          textAlign: 'center',
          lineHeight: '1.2'
        }}>
          Welcome to Project Soft Power
        </h1>

        <p style={{
          fontFamily: 'Roboto, sans-serif',
          fontSize: 'clamp(14px, 2vw, 18px)',
          color: '#5F6368',
          maxWidth: '600px',
          textAlign: 'center',
          marginBottom: '40px',
          lineHeight: '1.6',
          fontWeight: '400'
        }}>
          International Strategic Arts, Films and Cultural Development Initiative
        </p>

        <button
          onClick={handleEnter}
          style={{
            padding: '12px 32px',
            fontSize: '14px',
            fontFamily: 'Google Sans, Roboto, sans-serif',
            fontWeight: '500',
            color: '#1A73E8',
            background: 'transparent',
            border: '1px solid #DADCE0',
            borderRadius: '4px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            textTransform: 'none',
            letterSpacing: '0'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#F8F9FA';
            e.target.style.borderColor = '#1A73E8';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'transparent';
            e.target.style.borderColor = '#DADCE0';
          }}
        >
          Explore
        </button>

        <p style={{
          fontFamily: 'Roboto, sans-serif',
          fontSize: '13px',
          color: '#5F6368',
          fontStyle: 'italic',
          marginTop: '32px'
        }}>
          Founded by Leander Lee Marty
        </p>
      </div>
    </div>
  );
};

export default SplashScreen;
